import { useState } from "react";
import { getApiKey, setApiKey } from "../lib/session";
import { apiFetch } from "../lib/apiClient";

export default function KeyInput() {
  const [key, setKey] = useState(getApiKey());
  const [editing, setEditing] = useState(!key);
  const [status, setStatus] = useState<"idle" | "ok" | "fail" | "testing">("idle");

  function save() {
    setApiKey(key.trim());
    setEditing(false);
    setStatus("idle");
  }

  async function test() {
    if (!key) return;
    setApiKey(key.trim());
    setStatus("testing");
    try {
      await apiFetch("/api/v1/cert_types");
      setStatus("ok");
    } catch {
      setStatus("fail");
    }
  }

  const masked = key ? `${key.slice(0, 4)}…${key.slice(-4)}` : "";

  return (
    <div className="flex items-center gap-2 text-sm">
      <label className="text-slate-500">Key</label>
      {editing ? (
        <>
          <input
            type="password"
            className="border border-slate-300 rounded px-2 py-1 w-64 mono text-xs"
            placeholder="Paste API key"
            value={key}
            onChange={e => setKey(e.target.value)}
            autoComplete="off"
          />
          <button className="text-xs bg-brand-600 text-white rounded px-2 py-1" onClick={save}>
            Save
          </button>
          {key && (
            <button className="text-xs border border-slate-300 rounded px-2 py-1" onClick={test}>
              Test
            </button>
          )}
        </>
      ) : (
        <>
          <span className="mono text-xs text-slate-700">{masked}</span>
          <button className="text-xs text-brand-700 hover:underline" onClick={() => setEditing(true)}>
            Change
          </button>
        </>
      )}
      {status === "testing" && <span className="text-xs text-slate-500">Testing…</span>}
      {status === "ok" && <span className="text-xs text-emerald-600">✓ auth OK</span>}
      {status === "fail" && <span className="text-xs text-red-600">✗ auth failed</span>}
    </div>
  );
}
